import { getLocale, setLocale } from "../i18n";

const STORAGE_KEY = "boostscience_observatory_locale";

export function LanguageSwitcher() {
  const current = getLocale();
  const change = (next: "en" | "uk") => {
    if (next === current) return;
    try { localStorage.setItem(STORAGE_KEY, next); } catch {}
    setLocale(next);
    window.location.reload();
  };
  return (
    <div class="obs-language-switcher" role="group" aria-label="Language">
      <button type="button" class={current === "en" ? "is-active" : ""} aria-pressed={current === "en"} onClick={() => change("en")}>EN</button>
      <span aria-hidden="true">/</span>
      <button type="button" class={current === "uk" ? "is-active" : ""} aria-pressed={current === "uk"} onClick={() => change("uk")}>UA</button>
    </div>
  );
}
